<div class="tab-list">
	<slot></slot>
</div>

<style>
	.tab-list {
		display: flex;
		justify-content: center;
		/* border-bottom: 3px solid #5ab4bd; */
	}
</style>
